/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { CLOUDINARY } from './consts';

export const getImageUrl = (imgHash, transformations) => {
  let transformationString = '';
  if (transformations) {
    transformationString = ['f_webp', transformations].join()
  } else transformationString = 'f_webp'
  return (`${CLOUDINARY}/image/upload/${transformationString}/${imgHash}`);
}
export const getVideoSources = (videoHash, transformations) => {
  let transformationString = '';
  if (transformations) {
    transformationString = ['q_auto,c_limit', transformations].join()
  } else transformationString = 'q_auto,c_limit'
  return (
    <source
      src={`${CLOUDINARY}/video/upload/${transformationString}/${videoHash}.mp4`}
      type='video/mp4'
    />
  )
};

export const getComponentAttributes = (component) => ({ ...component?.data?.attributes });
